import React from 'react'
import { renderToString } from 'react-dom/server'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './exportStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { networkClosetListReadyAction, setNetworkClosetListPagesAction } from 'actions/exportActions'
import WireDistanceWarning from 'components/Wire/DistanceWarning'
import DescriptionBuilder from 'components/DeviceDescription/DescriptionBuilder'
import { connectedDevicesSelector, currentNetworkClosetSelector } from 'selectors/components'
import { CAMERA_SELECTED_COLORS } from 'helpers/globals'
import sortItems from 'helpers/sortItems'
import getTypeIconString from 'helpers/wiredDevices/getTypeIconString'

const mapStateToProps = state => {
  const { connectedDevices, totalDistance } = connectedDevicesSelector(state)

  return {
    currentNetworkCloset: currentNetworkClosetSelector(state),
    devices: connectedDevices,
    totalDistance,
    isImperial: state.ui.isImperial
  }
}

class NetworkClosetExportDetails extends React.Component {
  componentDidMount = _ => {
    const { currentNetworkCloset: { listStartIdx, listEndIdx }, networkClosetListReadyAction, setNetworkClosetListPagesAction } = this.props
    // hack to wait for paint before taking screenshot
    if (listStartIdx || listEndIdx) networkClosetListReadyAction()
    else setNetworkClosetListPagesAction(this.calculatePages())
  }

  calculatePages = _ => {
    const listHeight = this.refs.list.clientHeight
    let pages = []
    const children = Array.from(this.refs.list.children)
    let index = 0, subtotal = 0

    for (let i = 0; i < children.length; i++) {
      const childHeight = children[i].clientHeight
      if (childHeight > listHeight) {
        if (index < i) pages.push([index, i])
        pages.push([i, i + 1])
        subtotal = 0
        index = i + 1
      } else if (subtotal + childHeight > listHeight) {
        pages.push([index, i])
        subtotal = childHeight
        index = i
      } else subtotal += childHeight
    }

    if (pages.length > 0) pages.push([index, children.length])

    return pages
  }

  deviceIcon = device => {
    if (device.objType === 'camera') return <FontAwesomeIcon icon={['fac', 'camera-box']} style={{ color: CAMERA_SELECTED_COLORS[device.color], marginRight: '1rem', width: '4rem' }} />

    return (
      <div
        className={this.props.classes.wiredDeviceIcon}
        style={{ background: device.color }}
      >
        <FontAwesomeIcon
          icon={device.objType === 'wiredDevice' ? getTypeIconString(device.type) : ['far', 'microchip']}
          style={{ margin: 'auto' }}
        />
      </div>
    )
  }

  deviceRow = device => {
    const { isImperial, classes } = this.props

    return (
      <div key={device.id + device.objType} className={classes.device}>
        { this.deviceIcon(device) }
        <div style={{ flex: 1 }}>
          <span>{ device.name }</span>
          <div className={classes.distanceText}>
            Length: { device.distance }
            { device.showWarning && <WireDistanceWarning isImperial={isImperial} /> }
          </div>
        </div>
      </div>
    )
  }

  deviceLength = _ => {
    const { devices, currentNetworkCloset: { listStartIdx, listEndIdx } } = this.props

    if (listStartIdx || listEndIdx) return `${listStartIdx + 1}–${listEndIdx} of ${devices.length}`

    return devices.length > 0 ? `1–${devices.length} of ${devices.length}` : '0'
  }

  render() {
    const { devices, totalDistance, currentNetworkCloset, currentNetworkCloset: { listStartIdx, listEndIdx }, classes } = this.props
    const listDevices = sortItems(devices).slice(listStartIdx, listEndIdx)
    const showWarning = listDevices.some(device => device.showWarning)

    return (
      <div className={classes.details}>
        <span style={{ fontSize: '2.2rem', marginLeft: '.5rem' }}>Cabled Devices: {this.deviceLength()}</span>
        <span className={classes.distanceText} style={{ marginLeft: '.5rem' }}>Total Length: {totalDistance}</span>
        <div ref='list' className={classes.listContainer}>
          { devices.length > 0
              ? listDevices.map(this.deviceRow)
              : <em>No cabled devices</em>
          }
        </div>
        { showWarning &&
          <div className={classes.wireLengthWarning}>
            <FontAwesomeIcon icon='exclamation-triangle' />
            Copper Ethernet cables should not exceed 328 ft (100 m)
          </div>
        }
        <DescriptionBuilder currentDevice={currentNetworkCloset} type='networkCloset' isExport addPadding />
      </div>
    )
  }
}

export default connect(mapStateToProps, { networkClosetListReadyAction, setNetworkClosetListPagesAction })(injectSheet(style)(NetworkClosetExportDetails))



// WEBPACK FOOTER //
// ./src/components/NetworkClosetDetails/exportDetails.js